export type ConversionEvent =
  | 'Signup'
  | 'CheckoutClick'
  | 'CheckoutStart'
  | 'CheckoutFailed';
type Options = {
  props?: Record<string, string>;
  callback?: (result?: { status?: number; error?: unknown }) => void;
};
type Tracker = {
  (name: string, options?: Options): void;
  q?: unknown[];
  init?: (options?: object) => void;
  o?: object;
};
declare global {
  interface Window {
    plausible?: Tracker;
  }
}

export const bootstrap =
  'window.plausible=window.plausible||function(){(window.plausible.q=window.plausible.q||[]).push(arguments)};window.plausible.init=window.plausible.init||function(i){window.plausible.o=i||{}};window.plausible.init();';

export function syncOptOut() {
  let ignore = true;
  try {
    ignore = localStorage.getItem('plausible_ignore') === 'true';
  } catch {}
  document.cookie = `plausible_ignore=${ignore}; Path=/; SameSite=Lax; Max-Age=3600${location.protocol === 'https:' ? '; Secure' : ''}`;
  return ignore;
}
export function track(
  name: ConversionEvent,
  props?: Record<string, string>,
  callback?: Options['callback']
) {
  if (
    typeof window === 'undefined' ||
    process.env.NODE_ENV !== 'production' ||
    syncOptOut()
  )
    return;
  try {
    if (!window.plausible) {
      const queued: Tracker = (...args) => {
        queued.q?.push(args);
      };
      queued.q = [];
      window.plausible = queued;
    }
    window.plausible(name, { props, callback });
  } catch {}
}
export async function checkoutStarted(props?: Record<string, string>) {
  await new Promise<void>((resolve) => {
    const timer = setTimeout(resolve, 500);
    track('CheckoutStart', props, () => {
      clearTimeout(timer);
      resolve();
    });
  });
}
/** Call immediately before OAuth/email signup. Only an account created after this marker qualifies. */
export function beginSignup() {
  if (process.env.NODE_ENV !== 'production') return;
  document.cookie = `plausible_signup_start=${Date.now()}; Path=/; SameSite=Lax; Max-Age=3600${location.protocol === 'https:' ? '; Secure' : ''}`;
}

export async function checkoutReference() {
  if (process.env.NODE_ENV !== 'production' || syncOptOut()) return undefined;
  try {
    const response = await fetch('/api/analytics/checkout-reference', {
      method: 'POST',
      signal: AbortSignal.timeout(1200),
    });
    return response.ok
      ? ((await response.json()).reference as string | undefined)
      : undefined;
  } catch {
    return undefined;
  }
}
